const prefix = ['barcodeSetting'] as const

export const barcodeSettingQueryKeys = {
  rule: [...prefix, 'rule'] as const,
}
